import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const RoleManagementDialogTourConfig: AgTechTourConfig = {
    id: 'role-management-dialog-tour',
    name: 'Manage Roles Tour',
    steps: [
        {
            targetId: 'role-management-grid',
            title: 'Roles',
            description: 'Check a role to give it to this team member and uncheck it to remove it; changes apply immediately. Use the row menu to view the permissions a role grants.',
            position: 'top',
        },
    ]
}
